<template>
  <RecommendationAlgoliaCarousel
    v-if="isAlgoliaRecommendationBoughtTogetherActive"
    :recommendation-query="{
      objectIds: algoliaObjectIds,
      model: 'bought-together',
      options: {
        maxRecommendations: 12,
        queryParameters: {
          ruleContexts: [
            'without_protection',
            'only_accessory',
            'only_compatible',
          ],
        },
      },
    }"
    :title="i18n(translations.title)"
    :trackingData="{
      list: 'cross sell modal 1',
    }"
  />
  <RecommendationCarousel
    :options="{
      withCrossedPrice: true,
      withStartingFrom: false,
      withGrade: true,
      withAddToCart: true,
    }"
    :recommendation-query="{
      category: 'crossSellTwo',
      scope: 'addToCart',
      scopeId: `${listingId}`,
      limit: 12,
    }"
    :title="i18n(translations.title)"
    :trackingData="{
      list: 'cross sell modal 1',
    }"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import RecommendationAlgoliaCarousel from '@backmarket/nuxt-layer-recommendation/RecommendationAlgoliaCarousel.vue'
import RecommendationCarousel from '@backmarket/nuxt-layer-recommendation/RecommendationCarousel.vue'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useProductUrlToAlgoliaObjectId } from '~/scopes/product-core/components/presentationals/Recommendations/composables/useProductUrlToAlgoliaObjectId'

import translations from './CrossSellCarousel.translations'

const i18n = useI18n()
const experiments = useExperiments()
const isAlgoliaRecommendationBoughtTogetherActive =
  experiments['experiment.algoliaRecommendBoughtTogether'] === 'Algolia'
const algoliaObjectId = useProductUrlToAlgoliaObjectId()

const algoliaObjectIds = computed(() =>
  algoliaObjectId.value ? [algoliaObjectId.value] : null,
)

defineProps<{
  listingId: number
}>()
</script>
